//#region src/core/ui/seek-button/data.ts
/** @internal */
const SeekButtonDataAttrs = {
	/** Present when a seek is in progress. */
	seeking: "data-seeking",
	/** Indicates the seek direction: `"forward"` or `"backward"`. */
	direction: "data-direction"
};
//#endregion
export { SeekButtonDataAttrs };

//# sourceMappingURL=data.js.map